export const menuItems = {
  proteins: [
    { id: 1, name: 'Frango', calories: 163, protein: 31.5 },
    { id: 2, name: 'Patinho Moído', calories: 219, protein: 35.9 },
    { id: 3, name: 'Tilápia', calories: 128, protein: 26 },
    { id: 4, name: 'Tofu Firme', calories: 144, protein: 15.7 }
  ],
  carbs: [
    { id: 5, name: 'Arroz Integral', calories: 124, carbs: 25.8 },
    { id: 6, name: 'Batata-doce', calories: 76, carbs: 17.7 },
    { id: 7, name: 'Arroz Branco', calories: 128, carbs: 28.1 },
    { id: 8, name: 'Massa Integral', calories: 124, carbs: 26.5 }
  ],
  beans: [
    { id: 9, name: 'Carioca', calories: 76, carbs: 13.6 },
    { id: 10, name: 'Preto', calories: 77, carbs: 14.0},
    { id: 11, name: 'Vermelho', calories: 127, carbs: 22.8 },
    { id: 12, name: 'Lentilha', calories: 93, carbs: 16.3 }
  ],
  vegetables: [
    { id: 13, name: 'Brócolis', calories: 34, fiber: 3.3 },
    { id: 14, name: 'Abobrinha', calories: 17, fiber: 1.1 },
    { id: 15, name: 'Cenoura', calories: 41, fiber: 2.8 },
    { id: 16, name: 'Mix da Estação', calories: 28, fiber: 2.2 } // média estimada para mix
  ]
};

export const faqs = [
  {
    id: 1,
    question: 'Vocês montam dieta?',
    answer: 'Não. Executamos a sua prescrição nutricional. Seguimos as quantidades e combinações indicadas no seu plano.'
  },
  {
    id: 2,
    question: 'Preciso mandar a prescrição?',
    answer: 'Sim, para garantir precisão nas gramagens e nas combinações. Assim você tem certeza de que está recebendo exatamente o que foi prescrito.'
  },
  {
    id: 3,
    question: 'Qual a validade das marmitas?',
    answer: 'Até 30 dias congelado em freezer doméstico. Cada embalagem vem com etiqueta indicando data de produção e validade.'
  },
  {
    id: 4,
    question: 'Posso ajustar gramagens depois?',
    answer: 'Sim, pelo chat antes de cada produção. Você pode modificar as quantidades conforme seu nutricionista ajustar seu plano.'
  },
  {
    id: 5,
    question: 'Como funciona a entrega?',
    answer: 'Entregamos semanalmente, quinzenalmente ou mensalmente conforme seu plano. As marmitas chegam congeladas e as entregas são rastreadas.'
  },
  {
    id: 6,
    question: 'Posso pausar meu plano?',
    answer: 'Sim, você pode pausar ou cancelar a qualquer momento através do chat ou área do cliente.'
  }
];

export const plans = [
  {
    id: 1,
    name: 'Semanal',
    description: 'Entrega toda semana',
    meals: '14-21 marmitas',
    flexibility: 'Pausa fácil'
  },
  {
    id: 2,
    name: 'Quinzenal',
    description: 'Entrega a cada 15 dias',
    meals: '28-42 marmitas',
    flexibility: 'Melhor custo-benefício'
  },
  {
    id: 3,
    name: 'Mensal',
    description: 'Entrega mensal',
    meals: '56-84 marmitas',
    flexibility: 'Maior economia'
  }
];

export const howItWorksSteps = [
  {
    id: 1,
    title: 'Envie sua prescrição',
    description: 'Nos informe os macros e gramagens por refeição do seu plano nutricional.'
  },
  {
    id: 2,
    title: 'Monte as combinações',
    description: 'Escolha suas proteínas, carboidratos e vegetais favoritos do nosso cardápio.'
  },
  {
    id: 3,
    title: 'Conferimos e etiquetamos',
    description: 'Cada marmita é pesada e vem com etiqueta com o conteúdo.'
  },
  {
    id: 4,
    title: 'Entrega congelada e rastreada',
    description: 'Receba em casa, organize no freezer e tenha praticidade sem perder o rigor nutricional.'
  }
];

export const highlights = [
  {
    id: 1,
    title: 'Sem achismos',
    description: 'Não prescrevemos dieta. Seguimos rigorosamente a sua prescrição nutricional.'
  },
  {
    id: 2,
    title: 'Precisão',
    description: 'Pesagem por lote, etiquetas claras em cada marmita.'
  },
  {
    id: 3,
    title: 'Constância',
    description: 'Planos semanais, quinzenais ou mensais com pausas fáceis quando você precisar.'
  }
];